import generatePicker from "antd/es/date-picker/generatePicker";
import momentGenerateConfig from "rc-picker/lib/generate/moment";

// Generate a DatePicker that uses moment instead of dayjs
const MomentDatePicker = generatePicker(momentGenerateConfig);

// Export the DatePicker with all its subcomponents
export const DatePicker = MomentDatePicker;
